import { FC } from 'react';
import { DEFAULT_BUYER_IMAGES, DEFAULT_BUYER_LABELS } from './model';
import './BuyersAboutComponent.scss';

const BuyersAboutComponent: FC = () => {
	const buyerImages = [...DEFAULT_BUYER_IMAGES, ...DEFAULT_BUYER_IMAGES];
	return (
		<div className='buyers-container'>
			<h1 className='section-subtitle'>{DEFAULT_BUYER_LABELS.title}</h1>
			<div className='main-carousel-container'>
				<div className='fade-white'></div>
				<div className='carousel-container'>
					<div className='carousel-track'>
						{buyerImages.map((src, index) => (
							<img key={index} src={src} alt={`carousel-img-${index}`} className='carousel-image' />
						))}
					</div>
				</div>
			</div>
		</div>
	);
};

export default BuyersAboutComponent;
